/**
 * Gets a cache-busted profile image URL
 * @param {string} imageUrl - The original image URL
 * @returns {string} - The cache-busted URL
 */
export const getCacheBustedImageUrl = imageUrl => {
  if (!imageUrl) return '';
  const timestamp = new Date().getTime();
  return `${imageUrl}?t=${timestamp}`;
};
